import { Link } from "react-router-dom";
import { WarningCircle } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/roles";

export default function Unauthorized() {
  const { isAuthenticated, role } = useAuth();
  const homePath = isAuthenticated ? (ROLE_HOME[role] || "/login") : "/login";
  const homeLabel = isAuthenticated ? "Back to your dashboard" : "Back to sign in";
  return (
    <div
      data-testid="unauthorized-page"
      className="min-h-screen bg-background flex items-center justify-center px-6"
    >
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent/10">
          <WarningCircle size={28} weight="duotone" className="text-danger" />
        </div>
        <h1 className="font-heading text-3xl font-semibold tracking-tight text-neutral-900">
          Access not permitted
        </h1>
        <p className="mt-3 text-neutral-600">
          Your role doesn't have access to this area. If you believe this is a
          mistake, contact your organization admin.
        </p>
        <Link
          to={homePath}
          data-testid="unauthorized-back-link"
          className="mt-6 inline-flex rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-all hover:bg-primary-hover active:scale-[0.98]"
        >
          {homeLabel}
        </Link>
      </div>
    </div>
  );
}
